<template>
  <div
    :class="$style.status_cell"
    :style="{background: cellData.backgroundColor}"
  >
    <div
      :class="$style.text"
      :style="{color: cellData.labelColor}"
    >
      {{ cellData.label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cell: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    cellData() {
      return this.cell.row.original[this.cell.column.id];
    },
  },
};
</script>

<style module src="./cell.less" lang="less"></style>
